import { useState } from 'react';
import { useRecoilCallback, useRecoilValue } from 'recoil';

import AddBalance from '../../../Account/views/Cards/containers/AddBalance';
import ADD_BALANCE from '../../../assets/imgs/icon/add_balance.svg';
import STAR from '../../../assets/imgs/star-active.svg';
import { currentTransState } from '../../../atoms';
import { clearGiftCardSelection } from '../../../domains/Checkout/slice';
import Flex from '../../../GlobalComponents/Flex';
import Icon from '../../../GlobalComponents/Icon';
import { Modal } from '../../../GlobalComponents/Modal';
import { useAppDispatch } from '../../../reduxstore/hooks';
import { isCheckoutLoadingState, sendOrderErrorState } from '../../atoms';

type CardRowProps = {
	card: Card;
	isSelected: boolean;
	showAddBalance: boolean;
	balanceDue: number;
	onSelect: () => void;
};

export const CardRow: React.FC<CardRowProps> = ({
	card,
	showAddBalance,
	isSelected,
	balanceDue,
	onSelect
}) => {
	const dispatch = useAppDispatch();
	const [showModal, setShowModal] = useState<boolean>(false);
	const [selectedCard, setSelectedCard] = useState<number>(0);
	const onAddBalance = (cardNumber: number) => {
		setSelectedCard(cardNumber);
		setShowModal(true);
	};
	const toggleHandler = () => {
		setShowModal(!showModal);
	};
	const resetState = useRecoilCallback(({ reset }) => () => {
		reset(sendOrderErrorState);
		reset(isCheckoutLoadingState);
	});

	const currentTrans = useRecoilValue(currentTransState);

	const clearSelection = () => {
		resetState();
		dispatch(clearGiftCardSelection(Number(currentTrans?.total) || 0));
	};
	return (
		<>
			<Flex
				$flexDirection="column"
				$rowGap="15px"
				$placeContent="center space-between"
				$alignItems="center"
				onClick={onSelect}
				style={{
					border: isSelected
						? '1px solid #F47920'
						: '1px solid rgb(217, 217, 217)',
					borderRadius: '4px',
					padding: '10px 10px',
					height: '100px',
					cursor: 'pointer',
					pointerEvents:
						(Number(card.cash) > 0 && balanceDue > 0) || isSelected
							? 'auto'
							: 'none'
				}}
			>
				<Flex
					$flexDirection="row"
					$placeContent="center space-between"
					$alignItems="center"
					$backgroundColor="unset"
				>
					<Flex
						$flexDirection="row"
						$alignItems="center"
						$columnGap="5px"
						$backgroundColor="unset"
					>
						<div>Card #{card.card_number}</div>
						{card.default_payment_method && (
							<Icon
								$url={STAR}
								alt="favorite"
								$width={15}
								$height={15}
							/>
						)}
					</Flex>
					<div>${card.cash}</div>
				</Flex>
				{showAddBalance && (
					<Flex
						$flexDirection="row"
						$placeContent="center"
						$alignItems="center"
						$columnGap="10px"
						onClick={() => onAddBalance(card.card_number)}
						$backgroundColor="#fff"
						style={{
							padding: '5px 10px',
							width: 'unset',
							border: '1px solid #F47920',
							borderRadius: '4px',
							pointerEvents: 'auto'
						}}
					>
						<Icon
							$url={ADD_BALANCE}
							alt="favorite"
							$width={24}
							$height={24}
						/>
						Add Balance
					</Flex>
				)}
			</Flex>
			{showAddBalance && (
				<>
					<Modal
						isOpen={showModal}
						toggleHandler={toggleHandler}
						size="lg"
						backdrop="static"
						keyboard={false}
					>
						<AddBalance
							onClose={() => {
								setShowModal(false);
								clearSelection();
							}}
							cardNumber={selectedCard}
						/>
					</Modal>
				</>
			)}
		</>
	);
};
